import { X } from 'lucide-react';
import { DeckardIconWrapper } from './DeckardIcon';

export const CloseIcon = DeckardIconWrapper({ Icon: X });
